import React from "react";
import { Icon } from "antd";
import I18n from "../../../i18n";
import { Metrics } from "../../../theme/";
import Chart from "../../chart/";
import GraphCard from "../GraphCard";
import DataPercentList from "../../list/DataPercentList";
import { CallChannelIcon } from "../../../theme/Icons";
import { CallChannels } from "../../../util/appointments";
import { isFunction, ColorUtil, isAlive } from "../../../util";
import { GraphDataMaker } from "../../../util/helper/graph";
import { withTheme } from "styled-components";
import { getSplitRatio } from "../generics";

const makeMutateData = (theme, data, colorType)=>{
	const mutateData = GraphDataMaker.makeRenderDataOfObject(data, GraphDataMaker.strToLabel, (k,v)=>v, true);
	const colors = ColorUtil.generateVisualColorOfSize(theme, colorType, mutateData.length);
	return mutateData.map((e,i)=>({
		...e,
		label: CallChannels[e.item.toLowerCase()],
		icon:<CallChannelIcon style={{fontSize:24, marginRight:14, color:colors[i]}} channel={e.item.toLowerCase()} />
	}));
};

const CounPlatformChart = ({
	header = "",
	onHeaderClick,
	chart_id, 
	data, previousData,
	height, 
	chartHeight,
	colorType,
	style, 
	showLegend = true, 
	showColor = true,
	isVertical = false, 
	short = false,
	onClick,
	theme
})=>{
	const mutateData = makeMutateData(theme, data, colorType); 
	const compareMutateData = isAlive(previousData) ? makeMutateData(theme, previousData, colorType) : undefined;
	const mutateOnClick = isFunction(onClick) ? (select)=>onClick(select.item) : undefined;
	/**
     * This component use 'label' as labelKey instead of 'item'
     * because the 'item' label was mutate to difference word.
     */
	return (<GraphCard 
		style={{...style, marginTop:Metrics.button.spaceMargin}} 
		header={header}
		onHeaderClick={onHeaderClick}
		height={height}
		isVertical = {isVertical}
		chartWidthRatio={getSplitRatio(short)}
		fullLegendOnVertical={false}
		graph={
			<Chart.PieChart 
				labelKey='label'
				valueKey='count'
				data={mutateData} 
				height={chartHeight || height}
				visualColorKey={colorType}
				onClick={mutateOnClick}
			/>
		}
		legend={showLegend ? 
			<DataPercentList 
				percentDatas={mutateData}
				compareDatas={compareMutateData}
				textKey='label' valueKey='count'
				percentKey='percent'
				splitValue = {true}
				visualColorKey={colorType}
				showColor={showColor}
				showValue={!short}
				onClick={mutateOnClick}
			/> : undefined
		}
	/>
	);};
export default withTheme(CounPlatformChart);


// WEBPACK FOOTER //
// ./src/components/report/counseling/CounselingPlatformChart.js